import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import checkValue from '../../../../../../../../utils/values';
import FiduciaPdf from '../../../DownloadPdf/components/FiduciaPdfComponents';

function PdfPixIncome() {
  const incomeFaresState = useSelector(
    (reducer: IReducer) => reducer.incomeFares
  );

  return (
    <>
      <FiduciaPdf.ContainerLabelValues>
        <FiduciaPdf.Label>Tarifas de Pix recebidas:</FiduciaPdf.Label>
        <FiduciaPdf.Values isActive>
          {checkValue(incomeFaresState.pix.received).toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          })}
        </FiduciaPdf.Values>
      </FiduciaPdf.ContainerLabelValues>
      <FiduciaPdf.ContainerLabelValues>
        <FiduciaPdf.Label>Tarifas de Pix repassadas:</FiduciaPdf.Label>
        <FiduciaPdf.Values isActive>
          {checkValue(incomeFaresState.pix.passedOn).toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          })}
        </FiduciaPdf.Values>
      </FiduciaPdf.ContainerLabelValues>
      <FiduciaPdf.ContainerLabelValues>
        <FiduciaPdf.Label>Receita obtida com Pix:</FiduciaPdf.Label>
        <FiduciaPdf.Values isActive>
          {checkValue(incomeFaresState.ted.income).toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          })}
        </FiduciaPdf.Values>
      </FiduciaPdf.ContainerLabelValues>
    </>
  );
}

export default PdfPixIncome;
